/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { LockoutIcon, Text } from '@pancakeswap/uikit'
import { Switch } from 'antd'
import { USER_ROLE } from 'config/constants'
import { WalletType } from 'config/types/Wallet'
import { useTranslation } from 'contexts/Localization'
import { formatCode } from 'helpers/CommonHelper'
import { useTheme } from 'next-themes'
import Link from 'next/link'
import { memo } from 'react'
import styled from 'styled-components'
import { Box, Copy2Icon } from 'widgets'

const SwichStyled = styled(Switch)`
  &:not(.ant-switch-checked) {
    background-color: rgba(0, 0, 0, 0.25) !important;
  }
`

const DropdownUserMenu = ({
  userData,
  toggleMenu,
  onSignOut,
  myWallet,
}: {
  userData: any
  toggleMenu: () => void
  onSignOut: () => void
  myWallet: WalletType
}) => {
  const { t } = useTranslation()
  const { theme, setTheme } = useTheme()

  const onChangeSwichDarkMode = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light')
  }

  const onStopPropagation = (e) => {
    e?.stopPropagation()
  }

  return (
    <div
      className="w-[300px] overflow-hidden border-solid border-2 dark:border-primary-light border-gray-300 p-5 relative  dark:bg-[#0D0F07] bg-white"
      onClick={toggleMenu}
    >
      <div className="w-full translate-z-10">
        <div className="flex gap-2 items-start overflow-hidden">
          <img className="!w-16 !h-16 aspect-square !m-0 object-cover" src={userData?.avatar} alt="" />
          <div className="flex-1 overflow-hidden flex flex-col gap-0">
            <p className="text-xl font-bold truncate text-black dark:text-white">{userData?.fullName}</p>
            <div className="flex items-center gap-1">
              <p className="flex items-center gap-1 dark:text-white text-black">
                <span className="text-text-secondary">Wallet: </span>
                {formatCode(myWallet?.address, 5, 5)}
              </p>

              <div onClick={onStopPropagation}>
                <Copy2Icon textCopy={myWallet?.address} />
              </div>
            </div>
            <div className="flex items-center gap-1">
              <p className="flex items-center gap-1 dark:text-white text-black">
                <span className="text-text-secondary">UID: </span>
                {formatCode(userData?.id, 5, 5)}
              </p>
              <div onClick={onStopPropagation}>
                <Copy2Icon textCopy={userData?.id} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Link href="/profile" passHref>
        <p className="sign-out-btn cursor-pointer text-lg mt-3 text-black dark:text-white font-bold">
          {t('My Profile')}
        </p>
      </Link>

      {/* <div className="flex items-center justify-between mt-3">
        <p className="text-lg font-bold text-black dark:text-white">{t('Dark Mode')}</p>
        <SwichStyled onChange={onChangeSwichDarkMode} checked={theme === 'dark'} />
      </div> */}

      {userData?.role === USER_ROLE.ADMIN && (
        <>
          <Link href="/admin" passHref>
            <p className="sign-out-btn cursor-pointer text-lg mt-3 text-black dark:text-white font-bold">
              {t('Admin')}
            </p>
          </Link>
          <Link href="/reward" passHref>
            <p className="sign-out-btn cursor-pointer text-lg mt-3 text-black dark:text-white font-bold">
              {t('Reward')}
            </p>
          </Link>

          <Link href="/withdraw-requests" passHref>
            <p className="sign-out-btn cursor-pointer text-lg mt-3 text-black dark:text-white font-bold">
              {t('Withdraw Requests')}
            </p>
          </Link>
          <Link href="/commission-task" passHref>
            <p className="sign-out-btn cursor-pointer text-lg mt-3 text-black dark:text-white font-bold">
              {t('Commission task')}
            </p>
          </Link>
        </>
      )}

      <Box onClick={onSignOut} className="flex items-center mt-3 space-x-2">
        <LockoutIcon className="fill-black dark:fill-white" />

        <p className="sign-out-btn cursor-pointer hover:text-primary text-lg font-bold text-black dark:text-white">
          {t('Logout')}
        </p>
      </Box>
    </div>
  )
}

export default memo(DropdownUserMenu)
